import httpServices from 'services/http.service';
import { API_URLS } from 'constants/index';

export const getProducts = (category: string, currency: string) => (
  (httpServices.get(API_URLS.PRODUCT.LIST, { params: { category, currency } }))
);

export const getProduct = (category: string, originPrice: number) => (
  (httpServices.get(API_URLS.PRODUCT.GET, { params: { category, originPrice } }))
);

export const getPopularProduct = (currency?: string, lang?: string) => (
  (httpServices.get(API_URLS.PRODUCT.POPULAR, { params: { currency, lang } }))
);

export const getProductSearch = (term: string, currency: string, skip?: number, limit?: number) => (
  (httpServices.get(API_URLS.PRODUCT.SEARCH, { params: { term, currency, skip, limit } }))
);

export const getDiscountProducts = (currency: string, lang?: string, skip?: number, limit?: number) => (
  (httpServices.get(API_URLS.PRODUCT.DISCOUNT, { params: { currency, lang, skip, limit } }))
);

export const getReviews = (link: string) => (
  httpServices.get(API_URLS.PRODUCT.REVIEWS.replace('[:link]', link))
);

export const addReview = (link: string, body: { name: string; stars: number; description: string }) => (
  httpServices.post(API_URLS.PRODUCT.REVIEWS.replace('[:link]', link), body)
);

export const getFilteredProducts = (params: Record<string, string | number>) => (
  httpServices.get(API_URLS.PRODUCT.LIST_LINK, { params })
);
